import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import ReactPaginate from "react-paginate";
import individualServices from "../../Services/individualServices";
import { ChangeStatus, AddAmountModal } from "../../Components";
import Loader from "../../Components/Loader";
// import locationServices from '../../Services/locationServices'
import { MdDeleteForever, MdEdit, MdList } from "react-icons/md";
import { RiMoneyCnyBoxFill, RiMoneyDollarBoxFill } from "react-icons/ri";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { revenuecostService } from "../../Services/revenuecostService";
import Select from "react-select";
import { useLocation } from 'react-router-dom'
import CheckAccess from "../../Function/CheckAccess";
let currentPage1 = 1;

export const CustomerList = () => {
  const [individualsList, setIndividualsList] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [countryValue, setCountryValue] = useState("");
  const [isAmountModalOpen, setIsAmountModalOpen] = useState(false);
  const [modalData, setModalData] = useState({
    date: '',
    account_name: '',
    amount: '',
  });

  const history = useHistory();
  const imgRef = useRef();
  const location = useLocation()
  let user_type = localStorage.getItem("user_type")

  const formik = useFormik({
    initialValues: modalData,
    validationSchema: Yup.object({
      date: Yup.string().required("Date Required"),
      account_name: Yup.object().required("Account Name Required"),
      amount: Yup.string().required("Amount Required"),
    }),
    enableReinitialize: true,
    onSubmit: (values) => {
      // if (!isAmountModalOpen.quickBookRef) {
      //   toast.error("This user doesn't have quick book account")

      //   return false;
      // }
      // console.log("isAmountModalOpen.....", isAmountModalOpen);
      // console.log("values....", values);
      setLoader(true);
      let postData = {
        date: values.date,
        account_name: values.account_name.value,
        totalAmt: values.amount,
        email: isAmountModalOpen.user_email,
        // qbCustId: isAmountModalOpen.quickBookRef.userid
      };
      individualServices.addAdvanceAmount(postData).then((res) => {
        if (res.status) {
          setLoader(false);
          // history.push('individual-list')
          setIsAmountModalOpen(false);
          getIndividualsList();
        } else {
          setLoader(false);
          toast.error(res.message);
        }
      });
    },
  });

  const handleChange = (e) => {
    if(Object.keys(e)[1] === 'label'){
      setModalData({...modalData,account_name:e})
    }else{
      setModalData({...modalData, [e.target.name]:e.target.value})
    }
  }

  const listSelect = [
    { value: "81", label: "ENBD BANK" },
    { value: "83", label: "CASH IN HAND" },
    { value: "84", label: "RAK BANK" },
    { value: "105", label: "CASH FROM SALES-TELR" },
    { value: "156", label: "NETWORK INTERNATIONAL" },
  ];

 
  useEffect(() => {
    signInIntuit();
    getIndividualsList();
  }, [currentPage]);

  const getIndividualsList = () => {
    let param = { ...pagination, page: currentPage, item : 221 };
    // if (countryId) {
    //   param["search"] = countryId;
    //   param["page"] = 1;
    // }
    if (pagination.search) {
      param["page"] = 1;
    }
    individualServices.get_individual(param).then((res) => {
      if (res.status) {
        setLoader(false);
        setIndividualsList(res.data);
        setPagination({ ...pagination, ...res.pagination });
        // setPagination(res.pagination)
      } else {
        setLoader(false);
      }
    });
  };

  const onModalSubmit = () => {
    let postData = {
      id: isModalOpen._id,
      user_status: isModalOpen.user_status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
    };
    individualServices.update_individual(postData).then((res) => {
      setIsModalOpen(false);
      getIndividualsList();
    });
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  const signInIntuit = () => {
    var win;
    var parameters = "location=1,width=800,height=650";
    parameters +=
      ",left=" +
      (window.innerWidth - 800) / 2 +
      ",top=" +
      (window.innerHeight - 650) / 2;

    revenuecostService.qbookAuth().then((result) => {
      // Launch Popup
      // win = window.open(result, 'connectPopup', parameters);
      // this.props.history.push(result)
      if (!result.status) {
        localStorage.setItem("redirectUri", window.location.href);
        window.location.href = result.uri;
      }
    });
  };



  return (
    <div className="row">
      <Loader position={"fixed"} isShow={loader} />
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div>
                <input
                  type="text"
                  className={"form-control"}
                  placeholder="Search..."
                  onChange={(e) =>
                    setPagination({ ...pagination, search: e.target.value })
                  }
                  onKeyPress={(e) => e.key === "Enter" && getIndividualsList()}
                  onKeyUp={(e) =>
                    e.key === "Backspace" &&
                    pagination.search.length <= 0 &&
                    getIndividualsList()
                  }
                />
              </div>
              {/* <button
                className="btn btn-primary w-sm waves-effect waves-light mx-3"
                onClick={() => history.push("/add-Individuals")}
              >
                Add Individuals
              </button> */}
              {/* <input ref={imgRef} type="file" className="d-none" /> */}
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S no.</th>
                    <th> Name</th>
                    <th>Email</th>
                    <th>Contact No.</th>
                    <th>Advance Amount</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {individualsList.length > 0 &&
                    individualsList.map((item, key) => (
                      <tr key={key}>
                        <td className="text-body fw-bold">
                          {(pagination.page - 1) * pagination.limit + (key + 1)}
                        </td>
                        <td>
                          {item.user_full_name
                            ? item.user_full_name
                            : item.user_name}
                        </td>
                        <td>{item.user_email} </td>
                        <td>{item.user_phone_number}</td>
                        <td>{item?.advance_payment || 0}</td>
                        <td>
                          <span
                            className={
                              "badge rounded-pill font-size-12 pointer" +
                              (item.user_status === "ACTIVE"
                                ? " bg-success"
                                : " bg-soft-danger")
                            }
                            onClick={() => setIsModalOpen(item)}
                          >
                            {item.user_status}
                          </span>
                        </td>
                        <td>
                          {/* <RiBankLine
                                                 className="pointer"
                                                 color="#0323fe"
                                                 size="25px"
                                                /> */}
                          {/* Button trigger modal */}
                          {/* <MdDelete color="#fed203" size="30px"/> */}
                          {
                            (CheckAccess(421,"add") ||  user_type === "SUPERADMIN" )&& 
                          <RiMoneyDollarBoxFill
                            title="Add advance amount to customer"
                            className="pointer"
                            onClick={() => {
                              formik.resetForm();
                              setIsAmountModalOpen(item);
                            }}
                            color="#0323fe"
                            size="25px"
                          />
                          }
                          {/* <MdDeleteForever
                            // className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                            className="pointer"
                            color="red"
                            size="25px"
                            onClick={() => setDeleteModalOpen(item)}
                          /> */}
                          <MdList
                            className="pointer"
                            title="View Job List"
                            onClick={() =>
                              history.push(
                                "/job-amount-assign-list?email=" +
                                  item.user_email,
                                item
                              )
                            }
                            color="#0323fe"
                            size="25px"
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {individualsList.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}
            </div>
          </div>
          {individualsList.length > 0 &&
            pagination.totalRecord > pagination.limit && (
              <ReactPaginate
                previousLabel={
                  <img
                    src="assets/images/prev.svg"
                    height={15}
                    alt="not found"
                  />
                }
                forcePage={currentPage - 1}
                nextLabel={
                  <img
                    src="assets/images/next.svg"
                    height={15}
                    alt="not found"
                  />
                }
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={(e) => onPageChangeEvent(e)}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            )}
          {/* <Loader isShow={loader} /> */}
        </div>
        {Boolean(isModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(isModalOpen)}
            title="Update Status"
            message={`Are you sure want to ${
              isModalOpen.user_status === "ACTIVE" ? "Inactive" : "Active"
            } status ?`}
            onSubmitEvent={() => onModalSubmit()}
            handleClose={() => setIsModalOpen(false)}
          />
        )}
        {Boolean(deleteModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(deleteModalOpen)}
            title="Delete"
            message={`Are you sure want to delete?`}
            onSubmitEvent={() => setDeleteModalOpen(false)}
            handleClose={() => setDeleteModalOpen(false)}
          />
        )}
        {Boolean(isAmountModalOpen) && (
          <AddAmountModal
            isOpen={Boolean(isAmountModalOpen)}
            title="Advance Amount"
            message={`Are you sure want to add this amount ?`}
            onSubmitEvent={() => formik.handleSubmit()}
            handleClose={() => setIsAmountModalOpen(false)}
            buttonText={{ no: "Cancel", yes: "Submit" }}
            centerBtn
            child={
              <div>
                <form className="control-form">
                  <div className="mb-3 col-12 mx-auto">
                    <label className="form-label">Date</label>
                    <input
                      className="form-control"
                      type="date"
                      value={modalData.date}
                      name='date'
                      onChange={(e) => handleChange(e)}                   
                    />
                    {formik.touched.date && formik.errors.date ? (
                      <div className="ms-1 text-danger">{formik.errors.date}</div>
                    ) : null}
                  </div>
                  <div className="mb-3 col-12 mx-auto mt-3">
                    <label className="form-label">Account Name</label>
                    <Select
                      options={listSelect}
                      onChange={(e) => handleChange(e)}
                    />
                    {formik.touched.account_name && formik.errors.account_name ? (
                      <div className="ms-1 text-danger">{formik.errors.account_name}</div>
                    ) : null}
                  </div>
                  <div className="mb-3 col-12 mx-auto mt-3">
                    <label className="form-label">Advance Amount</label>
                    <input
                      type="number"
                      name='amount'
                      className="form-control"
                      onChange={(e) => handleChange(e)}
                      value={modalData.amount}
                      placeholder="Enter Amount"
                    />
                    {formik.touched.amount && formik.errors.amount ? (
                      <div className="ms-1 text-danger">{formik.errors.amount}</div>
                    ) : null}
                  </div>
                </form>
              </div>
            }
          />
        )}
      </div>
    </div>
  );
};
